import extend from 'extend';
import { unflatten } from 'flat';

import localConfig from './local'; // 로컬 설정이 가장 앞에 있어야함
import defaultConfig from './default';
import platformConfig from './platform';
import envConfig from './env';

export default extend(
  true,
  {},
  unflatten(defaultConfig),
  unflatten(platformConfig),
  unflatten(envConfig),
  unflatten(localConfig),
);
